import React, {
  useState,
  createContext,
  useContext,
  Dispatch,
  SetStateAction,
  useMemo,
} from "react";

type LangContextType = {
  lang: string;
  setLang: Dispatch<SetStateAction<string>>;
};

interface LangProviderProps {
  children: React.ReactNode;
}
const LangContext = createContext<LangContextType>({
  lang: "",
  setLang: () => {},
});

export const LangProvider = ({ children }: LangProviderProps) => {
  const [lang, setLang] = useState<string>("tr");

  // const values: LangContextType = { lang, setLang };
  const values = useMemo(() => ({ lang, setLang }), [lang, setLang]);

  return <LangContext.Provider value={values}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
